"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _vlpTableCarousel = _interopRequireDefault(require("../vlp-table-carousel.css"));
var BackgroundImageWithText = function BackgroundImageWithText(_ref) {
  var backgroundImage = _ref.backgroundImage,
    overlayText = _ref.overlayText,
    altText = _ref.altText,
    disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _vlpTableCarousel["default"].backgroundImageWithText
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: _vlpTableCarousel["default"].cardImage,
    src: backgroundImage,
    alt: altText
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: overlayText,
    className: _vlpTableCarousel["default"].title,
    tag: "p",
    disclaimerData: disclaimerData
  }));
};
var _default = BackgroundImageWithText;
exports["default"] = _default;